import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=76ccd4cc"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports